<template>
  <el-pagination
    class="page"
    v-if="total > 0"
    layout="sizes, prev, pager, next, slot"
    background
    :currentPage="pageIndex"
    :pageSize="pageSize"
    :pageSizes="[10, 20, 50, 100]"
    :total="total"
    @size-change="sizeChange"
    @current-change="currentChange"
  >
    <span class="page-info suffix">共{{ total }}条</span>
  </el-pagination>
</template>
<script>
export default {
  name: "pagination",
  props: {
    total: Number,
    pageIndex: Number,
    pageSize: Number,
    sizeChange: Function,
    currentChange: Function,
  },
  data() {
    return {};
  },
  methods: {},
  components: {},
};
</script>
<style scoped lang="scss">
.page-info {
  opacity: 0.8;
  font-size: 13px;
  color: #838393;
  font-weight: normal;
}
</style>
